import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

var store=new Vuex.Store({
  state:{
    students:['John Doe','Jane Doe','George Washington','John Adams','Thomas Jefferson','James Madison','James Monroe'],
    studentsQuick:['John Doe'],
    reasons:['Tardy','Disruption','Unpreparedness','Disrespect','Food','Disobedience','Uniform'],
    reasonsQuick:['Disruption','Unpreparedness','Disrespect','Food','Disobedience','Uniform'],
    tallyAmounts:{'Disruption':1,'Unpreparedness':1,'Disrespect':5,'Food':2,'Disobedience':10,'Uniform':5},
    teacher:'Tami Robledo',
    staff:['Brent Jones','Becky Veyon','Nathan Veyon','Tami Robledo']
  },
  mutations:{
    updateStudentsQuick(state,v){
      state.studentsQuick=v.list;
    }
  },
  actions:{
    checkQuicklist({commit,state}){
      var bool=0,
      list1=['Jane Doe','George Washington','John Adams'],
      list2=['Thomas Jefferson','James Madison','James Monroe'];
      setInterval(_=>{
        bool^=1;
        if(bool){
          commit({type:'updateStudentsQuick',list:list1});
        }
        else{
          commit({type:'updateStudentsQuick',list:list2});
        }
      },5e3);
    }
  }
});

export default store


// WEBPACK FOOTER //
// ./src/store.js